import { useFrame, useThree } from '@react-three/fiber'
import { useHeadStore } from '../store/headStore'
import { config } from '../config'
import { MathUtils } from 'three'

/**
 * 把头部姿态映射到相机，仅做视差。
 */
export function CameraRig() {
  const camera = useThree((s) => s.camera)
  useFrame(() => {
    const head = useHeadStore.getState()
    const k = config.head
    const targetRotY = head.active ? head.yaw * k.cameraYawWeight : 0
    const targetRotX = head.active ? -head.pitch * k.cameraPitchWeight : 0
    const targetPosX = head.active ? head.yaw * k.cameraPositionXWeight : 0

    camera.rotation.y = MathUtils.damp(camera.rotation.y, targetRotY, 10 * k.cameraLerp, 0.016)
    camera.rotation.x = MathUtils.damp(camera.rotation.x, targetRotX, 10 * k.cameraLerp, 0.016)
    camera.position.x = MathUtils.damp(camera.position.x, targetPosX, 10 * k.cameraLerp, 0.016)
  })
  return null
}
